// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1tHTO","productName":"Table_productName__3vFvt"};